module.exports = __webpack_public_path__ + "static/media/error_salim.92096b77.png";